"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var userDetailsStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        userDetailsWrapper: {
            borderTop: "1px solid " + palette.primaryDisabled.main,
            padding: '20px 0',
        },
        title: {
            fontFamily: typography.fontFamily2,
            paddingBottom: '20px',
        },
        element: {
            fontFamily: typography.fontFamily,
            padding: '2px 0',
        },
        userFirstName: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        userLastName: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        cardLogo: {
            maxWidth: '50px',
            height: 'auto',
            padding: 0,
        },
        userEmail: {},
        titleContent: {},
        elementContent: {},
    });
}, { name: 'GqlSummary_UserDetails' });
exports.default = userDetailsStyles;
